/**
 * SGKE361A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SafenoticeTargetConsumptiondevicelst {

    /**
     * 消費機器番号
     */
    consumptiondeviceNo?: string;
    /**
     * 消費機器番号履歴番号
     */
    setsubiNo?: string;
    /**
     * 消費機器機種コード
     */
    consumptiondeviceModelCode?: string;
    /**
     * 消費機器機種名
     */
    consumptiondeviceModelname?: string;
    /**
     * 製造年月
     */
    manufactureYm?: string;
    /**
     * 給排気方式コード
     */
    ventilationHoshikiCode?: string;
    /**
     * 給排気方式名
     */
    ventilationHoshikiMei?: string;
    /**
     * 接続状況コード
     */
    cnnctJokyoCode?: string;
    /**
     * 接続状況名
     */
    cnnctJokyoMei?: string;
    /**
     * 販売形態コード
     */
    salfrmCode?: string;
    /**
     * 販売形態名
     */
    saleKeitaiMei?: string;
    /**
     * メーカーコード
     */
    manufacturercode?: string;
    /**
     * メーカー名
     */
    manufacturerMei?: string;
    /**
     * 型式
     */
    model?: string;
    /**
     * 設置場所コード
     */
    installationlocationCode?: string;
    /**
     * 設置場所名
     */
    installationlocationMei?: string;
    /**
     * 不適合コード
     */
    nonconformityCode?: string;
    /**
     * 不適合内容
     */
    nonconformityCont?: string;
    /**
     * CO値コード
     */
    covalueCode?: string;
    /**
     * CO値名
     */
    covalueMei?: string;
}

